let clientInstance;
function injectClient(instance) {
    clientInstance = instance;
}
function getClient() {
    if (!clientInstance) throw new Error('Client instance has not been injected.');
    return clientInstance;
}
export { getClient, injectClient };
